<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="text-center">Visits</h3>
          <v-card>
            <v-card-text>
              <form @submit.prevent="downloadReport">
                <v-layout wrap>
                  <v-flex xs4 class="px-1">
                    <v-select label="Report Length" :items="types" v-model="report.type" :hint="report.type + ' from '+report.date" persistent-hint></v-select>
                  </v-flex>
                  <v-flex xs8 class="px-1">
                    <date-range-picker v-model="dates" range label="Select Date Range" v-if="report.type == 'range'"></date-range-picker>
                    <date-picker v-model="report.date" label="Start Date" required v-else></date-picker>
                  </v-flex>
                </v-layout>
                <v-btn small class="pull-right primary" type="submit" :disabled="!report.date && !dates" :loading="loading">Search
                  <v-icon right>mdi-calendar-search</v-icon>
                </v-btn><br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-data-table :headers="headers" :items="visits">
                <template v-slot:[`item.client.name`]="{ item }">
                  <inertia-link :href="'/clients/' + item.client.id">{{ item.client.name }}</inertia-link>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  {{ moment(item.created_at).format('lll') }}
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <p class="text-muted">Range from {{ date }} to {{ end_date }}</p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Reports'
  const DatePicker = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/datepicker.vue')
  const DateRangePicker = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/daterangepicker')

  export default {
    name: 'visits',
    layout,
    props: [
      'visits',
      'date',
      'type',
      'range',
      'end_date'
    ],
    components: {
      DatePicker,
      DateRangePicker,
    },
    metaInfo () {
      return {
        title: 'Visits - Reports',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        report: {
          type: this.type,
          date: this.date
        },
        types: [
          {
            text: 'Date Range', value: 'range'
          },
          'daily', 'weekly', 'fortnightly', 'monthly', 'quartely', 'bi-annually', 'yearly',
        ],
        headers: [
          {
            text: 'Name', value: 'client.name',
          },
          {
            text: 'Age', value: 'client.age-group',
          },
          {
            text: 'Sex', value: 'client.gender',
          },
          {
            text: 'Date', value: 'date',
          },
          {
            text: 'Created', value: 'created_at'
          }
        ],
        loading: false,
        dates: this.range,
      }
    },
    methods: {
      downloadReport () {
        if (!this.report.date && (!this.dates || this.dates.length != 2)) {
          return
        }
        if (this.report.type === 'range') {
          var query = '?range=' + this.dates
        } else {
          var query = '?type=' + this.report.type + '&date=' + this.report.date
        }
        this.loading = true
        this.$inertia.visit('/reports/visits' + query,  {
          preserveState: true,
          preserveScroll: true,
          onFinish: () => {
            this.loading = false
          }
        })
      }
    },
    watch: {
      'report.type': function (value) {
        this.report.date = ''
      },
      'report.date': 'downloadReport',
      'dates': 'downloadReport'
    }
  }
</script>
